var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-grids"},[_c('div',{staticClass:"recommended"},[_c('layoutLiveWatch',{attrs:{"liveData":_vm.liveData,"routePath":_vm.liveRoutePath,"embedCode":_vm.embedCode}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }